var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgred"},[_c('h2',[_vm._v("契合科技营销产品矩阵，新金融，新营销")]),_vm._v(" "),_c('p',[_vm._v("实施运营⼀条龙服务，让您省时省⼼做好数字化运营工作")]),_vm._v(" "),_c('a',{staticClass:"shiyong",on:{"click":_vm.denglu}},[_vm._v("立即试用")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3acca8a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bgred.vue
// module id = null
// module chunks = 